import { List, ListItem, ListItemText } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { RADIO_CHECKED_ICON, RADIO_UNCHECKED_ICON } from '../assets/constants/Icons'
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware'
import { LOCAL_STORAGE, LS_LOCKER_BANK_INFO } from '../assets/constants/BrowserStorageKeys'
import { getUnitLabelParams } from '../lib/Utils'

const LockerItem = (props) => {
  const { locker, selectSlider, onPress } = props
  const { t } = useTranslation()
  const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO)
  return (
    <List key={locker} className='locker-list'>
      <ListItem className='locker-content' onClick={onPress}>
        <ListItemText className='locker-number' primary={t('locker_number_display_text', { ...getUnitLabelParams(lockerBankInfo?.LockerBankType, t), lockerNumber: locker })} />
        {selectSlider ? (
          <RADIO_CHECKED_ICON />
        ) : (
          <RADIO_UNCHECKED_ICON />
        )}
      </ListItem>
    </List>
  )
}

export default LockerItem
